/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-unresolved */
import * as React from 'react';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';

const DecimalNumberField = React.forwardRef(function DecimalNumberField(props, ref) {
  const { name, onChange, ...other } = props;

  return (
    <NumericFormat
      {...other}
      getInputRef={ref}
      allowNegative={false}
      onValueChange={(values) => {
        onChange({
          target: {
            name,
            value: values.value
          }
        });
      }}
      thousandSeparator
      decimalScale={2}
      fixedDecimalScale
      valueIsNumericString
      // prefix="$"
    />
  );
});

DecimalNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default DecimalNumberField;
